/* eslint-disable import/prefer-default-export */

/** email 业务类型 */
export const EmailType = {
    CodeLogin: 'webEmailCodeLogin', // 验证登录
    StaticLogin: 'webEmailStaticLogin', // 静密登录
    Register: 'webRegister', // 注册
    ResetPassword: 'webResetPassword', // 修改密码
    RevokeAccount: 'acctDeletion', // 账号注销
};
